
define('tpl!ui/generis/widget/checkBox/checkBox', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data,depth1) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <div class=\"option\">\n                <label>\n                    <input\n                        type=\"checkbox\"\n                        name=\""
    + escapeExpression(((stack1 = (depth0 && depth0.uri)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"\n                        value=\""
    + escapeExpression(((stack1 = (depth0 && depth0.uri)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"\n                        ";
  stack1 = (helper = helpers.includes || (depth1 && depth1.includes),options={hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data},helper ? helper.call(depth0, (depth1 && depth1.values), (depth0 && depth0.uri), options) : helperMissing.call(depth0, "includes", (depth1 && depth1.values), (depth0 && depth0.uri), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n                    <span class=\"icon-checkbox\"></span>\n                    "
    + escapeExpression(((stack1 = (depth0 && depth0.label)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n                </label>\n            </div>\n            ";
  return buffer;
  }
function program2(depth0,data) {
  
  
  return "\n                        checked=\"true\"\n                        ";
  }

  buffer += "<div class=\"ui-generis-widget check-box\">\n    <div class=\"left\">\n        ";
  stack1 = self.invokePartial(partials['ui-generis-widget-label'], 'ui-generis-widget-label', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    <div class=\"right\">\n        <div class=\"check-box-input\">\n            ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.range), {hash:{},inverse:self.noop,fn:self.programWithDepth(1, program1, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </div>\n    </div>\n</div>\n";
  return buffer;
  });
});

